import { unByKey as unByKeyObservable } from 'ol/Observable'
import OverviewMap from 'ol/control/OverviewMap'

/** Permet d'exposer directement des outils d'OpenLayers */

/**
* Permet de ne plus ecouter un event
* @param {Listener} listener clé renvoyées par on ou once
*/
export function unByKey (event) {
  unByKeyObservable(event)
}

export function createOverviewMapControl (options) {
  return new OverviewMap(options)
}

export default {
  unByKey,
  createOverviewMapControl,
}
